import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CookieOption } from './CookieDetailOption';
import { ButtonsWrapper, CookieList, DetailContent, DetailWrapper, TitleDetail } from './styles';
import { Button } from '../../Button';
import { Icon } from '../../Icon';
import { Link } from '../../Link';
import { Markdown } from '../../Markdown';
import { Text } from '../../Text';
export var CookieDetail = function (_a) {
  var content = _a.content,
    cookiesConsent = _a.cookiesConsent,
    onBackLinkClick = _a.onBackLinkClick,
    onConsentClick = _a.onConsentClick,
    onSwitchOption = _a.onSwitchOption,
    onSaveClick = _a.onSaveClick;
  var cookies = Object.entries(cookiesConsent);
  return _jsxs(DetailWrapper, {
    children: [_jsx("div", {
      children: _jsxs(Link, {
        onClick: onBackLinkClick,
        children: [_jsx(Icon, {
          size: 11,
          type: "icon-chevron-left-big",
          style: {
            marginRight: 8,
            marginTop: -4,
            verticalAlign: 'middle'
          }
        }), content.backLink]
      })
    }), _jsxs(DetailContent, {
      children: [_jsx(TitleDetail, {
        el: "h5",
        styleName: "title5",
        children: content.title
      }), _jsx(Markdown, {
        markdown: content.description
      }), _jsx(TitleDetail, {
        el: "h6",
        styleName: "title6",
        children: content.preferences.title
      }), _jsxs(CookieList, {
        children: [_jsxs("li", {
          children: [_jsx(Text, {
            el: "span",
            styleName: "bodyRegular",
            children: _jsx("strong", {
              children: content.preferences.option.mandatory.label
            })
          }), _jsx(Text, {
            el: "span",
            styleName: "bodyRegular",
            children: content.preferences.option.mandatory.note
          }), _jsx(Text, {
            el: "p",
            styleName: "bodySmall",
            variant: "secondary",
            children: content.preferences.option.mandatory.description
          })]
        }), cookies.map(function (_a, idx) {
          var key = _a[0],
            value = _a[1];
          return _jsx("li", {
            children: _jsx(CookieOption, {
              content: content.preferences.option[key],
              name: key,
              isAllowed: value === 'granted',
              onOptionChange: onSwitchOption
            })
          }, idx);
        })]
      })]
    }), _jsx("div", {
      children: _jsxs(ButtonsWrapper, {
        children: [_jsx(Button, {
          role: "secondary",
          onClick: onSaveClick,
          size: "small",
          children: content.secondaryCta
        }), _jsx(Button, {
          role: "primary",
          onClick: onConsentClick,
          size: "small",
          children: content.primaryCta
        })]
      })
    })]
  });
};